class MegaMenu {
  constructor(item) {
    this.item = item;
    this.content = this.item.querySelector(".mega-menu__content");

    this.bindMouseOver();
  }

  bindMouseOver() {
    this.item.addEventListener("mouseover", () => {
      this.item.setAttribute("open", true);
      this.content.addEventListener("mouseover", () => {
        this.item.setAttribute("open", true);
      });
      this.content.addEventListener("mouseleave", () => {
        this.item.removeAttribute("open");
      });
      this.item.addEventListener("mouseleave", () => {
        this.item.removeAttribute("open");
      });
    });
  }
}

const items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details.mega-menu");
items.forEach((item) => new MegaMenu(item));
